<template>
  <div>
    <Collapse v-model="value1" simple style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle :titleText="$t('基本信息')" />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          :disabled="true"
          style="margin: 30px 30px 0 30px"
        >
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('员工工号')">
                <Input v-model="formItem.serialnumber" :disabled="isHistory">
                </Input>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('员工姓名')">
                <Input v-model="formItem.userName" :disabled="true" />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('职位名称')">
                <Input v-model="formItem.positionName" :disabled="true" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row type="flex" justify="space-between">
           <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem :label="$t('公司')">
                     <Input disabled v-model="formItem.orgsname2"/>
                  </FormItem>
                </Col>                
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem :label="$t('地区')">
                     <Input disabled v-model="formItem.orgsname4"/>
                  </FormItem>
                </Col>
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem :label="$t('部门')">
                    <Input disabled v-model="formItem.orgsname5"/>
                  </FormItem>
                </Col>
          </Row> -->
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('试用期结束日 ')">
                <Date-picker
                  v-model="formItem.probationenddate"
                  disabled
                  type="date"
                  placeholder=""
                  style="width: 100%"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle :titleText="$t('评估决定')" />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          style="margin: 30px 30px 0 30px"
        >
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估编码')">
                <Input
                  v-model="formItem.reviewCode"
                  :disabled="isHistory || is_report"
                />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('中文描述')">
                <Input
                  v-model="formItem.reviewCname"
                  :disabled="isHistory || is_report"
                />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('英文描述')">
                <Input
                  v-model="formItem.reviewEname"
                  :disabled="isHistory || is_report"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('开始日期')">
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="formItem.beginDate"
                  :disabled="isHistory || is_report"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('结束日期')">
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="formItem.endDate"
                  :disabled="isHistory || is_report"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估日期')">
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="formItem.reviewDate"
                  :disabled="isHistory || is_report"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估类型')">
                <Select
                  v-model="formItem.reviewType"
                  :clearable="true"
                  :disabled="isHistory || is_report"
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in reviewTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估人')">
                <Input
                  v-model="formItem.reviewPerson"
                  :disabled="isHistory || is_report"
                />
              </FormItem>
            </Col>
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('评估结果')">
                <Input
                  v-model="formItem.result"
                  :disabled="isHistory || is_report"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="$t('批准人')">
                <Input v-model="formItem.apprPerson" :disabled="isHistory" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="14" :xs="24" :sm="24" :md="24" :lg="24">
              <FormItem span="3" :label="$t('备注')">
                <Input
                  type="textarea"
                  v-model="formItem.comment"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
          </Row>
          <Row class="btnRight">
            <Col>
              <Button
                class="applyBtnRight"
                v-if="!getQueryVariable('history')"
                @click="comf"
                >{{ $t("同意") }}</Button
              >
              <Button
                class="applyBtnRight"
                v-if="!getQueryVariable('history')"
                @click="returnThelastonePage()"
                >{{ $t("驳回") }}</Button
              >
              <Button class="applyBtnRight" @click="returnPage()">返回</Button>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle :titleText="$t('审批历史')" />
        <Table
          border
          :columns="lvLiMessage"
          :data="data1"
          slot="content"
          style="margin: 30px 30px 0 30px"
        ></Table>
      </Panel>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Collapse>
    <!-- 驳回审批意见 -->
    <Modal
      v-model="showdataRejected"
      :title="$t('请填写驳回意见')"
      width="500"
      :mask-closable="false"
    >
      <Form ref="returnopin" :model="rejectMessage" :rules="ruleValidate">
        <FormItem prop="message2">
          <Input
            v-model="rejectMessage.message2"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="handle1">{{ $t("确定") }}</Button>
        <Button @click="cancell">{{ $t("取消") }}</Button>
      </div>
    </Modal>
    <!-- 同意审批意见 -->
    <Modal
      v-model="showagreedata"
      :title="$t('请填写审批意见')"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="agreeBtnOk">{{ $t("确定") }}</Button>
        <Button @click="cancell">{{ $t("取消") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  components: {},
  data() {
    return {
      showagreedata: false,
      date: new DateUtil(),
      value1: [1, 2, 4],
      formItem: { probation_period_decision: "" },
      data1: [],
      reviewTypeList: [],
      probationPeriod: [],
      prevent: false,
      isHistory: false,
      spinShow: false,
      is_report: false,
      showdataRejected: false,
      rejectMessage: {
        message2: ""
      },
      approval_agent_flg: 0
    };
  },
  computed: {
    lvLiMessage() {
      return [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          width: "280",
          key: "status",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "435"
        }
      ];
    },
    ruleValidate() {
      return {
        message2: [
          { required: true, message: this.$t("请填写驳回意见") + "！" }
        ]
      };
    }
  },
  created() {
    this.is_report = this.getQueryVariable("is_report") ? true : false;
    this.isHistory = this.getQueryVariable("history") ? true : false;
    this.approval_agent_flg = this.getQueryVariable("approval_agent_flg");
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    returnPage() {
      //1审批 0 申请
      if (this.getQueryVariable("history") == 1) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else if (this.getQueryVariable("is_report") == "true") {
        this.$router.push(
          "/5B5A90DA0767AD6E81F616E2428F769BE0844B1BA2085C64/A3FFBEBFDB713E27?tabIndex=3"
        );
      } else if (this.approval_agent_flg === "1") {
        this.$router.push(
          "/C3904BCDD542D40ECF5E49DF3A1F39D9C587E33DA46A7207/93691ABC763FC67F"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    },
    returnThelastonePage() {
      this.showdataRejected = true;
    },
    handle1() {
      this.$refs["returnopin"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message2,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.spinShow = true;
          axios.post("/process/execute", arr).then(res => {
            this.spinShow = false;
            this.prevent = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    getUserData() {
      let arr = {
        instanceId: this.getQueryVariable("instanceId")
      };
      axios.post("/probation/searchProbationInfo", arr).then(res => {
        if (res) {
          this.formItem = res.basicInfo;
          this.reviewTypeList = res.optionList;
          this.formItem.userName = res.basicInfo.applyName;
          this.formItem.serialnumber = res.basicInfo.applySerialnumber;
          this.formItem.positionName = res.basicInfo.applyPositionName;
          this.formItem.probationenddate = res.basicInfo.endProbationPeriod;
          this.formItem.comment = res.basicInfo.comments;
          this.data1 = res.logMap;
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    agreeBtnOk() {
      this.showagreedata = false;
      this.spinShow = true;
      let arr1 = {
        instanceId: this.getQueryVariable("instanceId"),
        comments: this.formItem.comment,
        beginDate: this.date.dateVal(this.formItem.beginDate, "YYYY-MM-DD"),
        endDate: this.date.dateVal(this.formItem.endDate, "YYYY-MM-DD"),
        reviewDate: this.date.dateVal(this.formItem.reviewDate, "YYYY-MM-DD"),
        reviewCode: this.formItem.reviewCode,
        reviewCname: this.formItem.reviewCname,
        reviewEname: this.formItem.reviewEname,
        reviewType: this.formItem.reviewType,
        reviewPerson: this.formItem.reviewPerson,
        result: this.formItem.result,
        apprPerson: this.formItem.apprPerson
      };
      axios.post("/probation/updateApplyProbation", arr1).then(res => {
        let arr2 = [
          {
            objData1: { approval_result: "0" },
            stringData1: this.getQueryVariable("taskId"),
            stringData2: this.rejectMessage.message,
            type: "B17"
          }
        ];
        axios.post("/process/execute", arr2).then(res => {
          if (res) {
            let arr3 = {
              ...this.formItem,
              endProbationPeriod: this.date.dateVal(
                this.formItem.endDate,
                "YYYY-MM-DD"
              )
            };
            axios.post("/probation/writeBackProbationInfo", arr3).then(res => {
              this.spinShow = false;
              this.$Message.info(this.$t("Approval_Completed"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            });
          }
        });
      });
    },
    comf() {
      this.showagreedata = true;
    },
    cancell() {
      this.showdataRejected = false;
      this.showagreedata = false;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/process/Apply/ProbationApproval.vue